import axios from "axios";
import {loginUrl} from '../plugins/common.js'
import notify from "devextreme/ui/notify";

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL
});

axiosInstance.interceptors.request.use(function (config) {
    config.headers.setAuthorization(`Bearer ${localStorage.getItem('auth_token')}`);
    config.headers.setContentType("application/x-www-form-urlencoded");
    return config
}, function (error) {
    return Promise.reject(error)
});

axiosInstance.interceptors.response.use(
    function (response) {
        return response
    },
    function (error) {
        if (error.response) {
            if (error.response.status == 401) {
                localStorage.removeItem('auth_token');
                window.location.href = loginUrl;
            } else if (error.response.status == 403) {
                notify({message: "Доступ запрещен!", type: "error"}, {position: "center"});
            }
            console.log(error.response.data.message);
            notify({message: "Произошла непредвиденная ошибка ", type: "error"}, {position: "center"});
        } else {
            console.log("Неизвестная ошибка");
        }
    })

export default axiosInstance;